import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { rememberPaymentFlow } from 'utilities/analytics/paymentFlow'
import { postTransactions } from 'services/easyPay'

export default function useSetTransactionsWallet(jsonData: any) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ITransactionPayload) => {
            return postTransactions(payload)
        },
        onSuccess: (result, variables) => {
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    type: 'pay-for-others',
                    data: jsonData ? jsonData : [],
                    //@ts-ignore
                    pk: result?.pk,
                    //@ts-ignore
                    gateway: result?.gateway,
                })
            )
            posthog.capture('payment_gateway_redirect', { flow_type: 'pay_for_other_wallet', transaction_pk: (result as any)?.pk, gateway: (result as any)?.gateway })
            rememberPaymentFlow({
                flow_type: 'pay_for_other_wallet',
                amount: (variables as any)?.amount ?? null,
                gateway: String((result as any)?.gateway ?? ''),
                box_id: (variables as any)?.transaction?.ctx_id ?? null,
                box_type: 'mnp',
            })
            //@ts-ignore
            window.location.replace(result?.pay_url)
        },
        onError: () => {
            posthog.capture('payment_initiate_failed', { flow_type: 'pay_for_other_wallet' })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutateTransactionWallet: mutate }
}
